/*
 * Filename: d:\projects\AutoFiFront\src\Content\OrderBy\OrderBySelected\OrderBySelected.tsx
 * Path: d:\projects\AutoFiFront
 * Created Date: Monday, January 30th 2023, 6:04:12 pm
 * Author: Jonathan MAZAT
 *
 * Copyright (c) 2023 Autobuy SAS
 */

import React from "react";
import styles from "Content/OrderBy/OrderBySelected/OrderBySelected.module.css";
import translator from "MultiLanguage/TranslationWrapper";
import { FaSortAmountDownAlt } from "react-icons/fa";
import { FaSortAmountUpAlt } from 'react-icons/fa';
import OrderByStyled from "Theme/Component/OrderByStyled";

type OrdeBySelectedType = {
    name: string,
    sort: string,
    changeState: (currentlyActive: string, order: string) => void,
    themeColor: string
};

function OrderBySelected (props: OrdeBySelectedType) {
    const getParentId: any = (parentElement: any, limit=10)=>{
        if (limit <= 0)
            return "";
        if(parentElement.id !== "")
            return parentElement.id;
        return getParentId(parentElement.parentElement, limit - 1);
    };

    return(
        <React.Fragment>
            {props.sort == "notActivated" &&
                <OrderByStyled border={0} borderHover={4} bgColor={props.themeColor} id={props.name} onClick={(e:any) => { e.target.id != "" ? props.changeState(e.target.id, "asc"): props.changeState(getParentId(e.target.parentElement), "asc")}}>
                    <FaSortAmountDownAlt className={`${styles.iconNeutral}`} />
                    {translator.decode(`orderby.${props.name}`)}
                </OrderByStyled>
            }
            {props.sort == "asc" &&
                <OrderByStyled border={4} bgColor={props.themeColor} id={props.name} onClick={(e:any) => { e.target.id != "" ? props.changeState(e.target.id, "desc"): props.changeState(getParentId(e.target.parentElement), "desc")}}>
                    <FaSortAmountDownAlt/>
                    {translator.decode(`orderby.${props.name}`)}
                </OrderByStyled>
            }
            {props.sort == "desc" &&
                <OrderByStyled border={4} bgColor={props.themeColor} id={props.name} onClick={(e:any) => { e.target.id != "" ? props.changeState(e.target.id, "notActivated"): props.changeState(getParentId(e.target.parentElement), "notActivated")}}>
                    <FaSortAmountUpAlt/>
                    {translator.decode(`orderby.${props.name}`)}
                </OrderByStyled>
            }
        </React.Fragment>
    );
}

export default OrderBySelected;
